import { render, staticRenderFns } from "./Applicant.vue?vue&type=template&id=2e425e47"
import script from "./Applicant.vue?vue&type=script&lang=js"
export * from "./Applicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports